import {toInt} from '@/library/math';

import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const WhistleblowerView = () => import('../views/whistleblower/WhistleblowerView.vue');
const WhistleblowerList = () => import('../views/whistleblower/WhistleblowerList.vue');

let meta: MetaData = {module: 'whistleblower'};

let whistleblower: RouteRecordRaw[] = [
    {
        name: 'whistleblower',
        path: '/employee/whistleblower',
        redirect: {
            name: 'whistleblower-list',
            params: {role: 'mine'},
        },
    },
    {
        name: 'whistleblower-list',
        path: '/employee/whistleblower/whistleblower/list/role/:role(all|mine)?',
        component: WhistleblowerList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                role: route.params.role || 'mine',
            };
        },
    },
    {
        name: 'whistleblower-entry-view',
        path: '/employee/whistleblower/whistleblower/view/id/:id',
        component: WhistleblowerView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        path: '/whistleblower/:wildcard*',
        redirect: {
            name: 'whistleblower-list',
            params: {role: 'mine'},
        },
    },
];

export default whistleblower;
